import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
 
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
//import { ToastrService } from 'ngx-toastr';


@Injectable()
export class ApiService {

  loading: boolean = false;
  toastr: any;
  authService: any;
  isLoggedIn: boolean;

  constructor(public http: HttpClient, public router: Router,  private snackBar: MatSnackBar) {}

  httpGet(url: string, p0: { headers: HttpHeaders; }) {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/x-www-form-urlencoded');

    const token = sessionStorage.getItem('Token');
    if (token) {
      headers = headers.append('Authorization-Token', token);
    }

    return this.http.get(url, { headers: headers }).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err) => {
        if (err.status === 401) {
          this.toastr.error('Your session has expired', 'Error 401');
          this.authService.logout();
        } else {
          this.toastr.error("Something's gone wrong", 'Error');
        }
        const error = err.error.message || err.statusText;
        return throwError(error);
      })
    );
  }
 
  // httpPost(url: string, body: any) {
  //   let headers = new HttpHeaders();
  //   headers = headers.append('Content-Type', 'application/x-www-form-urlencoded');

  //   const token = sessionStorage.getItem('Token');
  //   if (token) {
  //     headers = headers.append('Authorization-Token', token);
  //   }

  //   return this.http.post(url, body, { headers: headers }).pipe(
  //     map((response: any) => {
  //       return response;
  //     }),
  //     catchError((err) => {
  //       if (err.status === 401) {
  //         this.toastr.error('Your session has expired', 'Error 401');
  //         this.authService.logout();
  //       } else {
  //         this.toastr.error("Something's gone wrong", 'Error');
  //       }
  //       const error = err.error.message || err.statusText;
  //       return throwError(error);
  //     })
  //   );
  // }
  // Adjust the ApiService method

  httpPosst(url: string, body: any, options?: any): Observable<any> {
    return this.http.post(url, body, options);
  }
  
  
  httpPost(url: string, body: any,) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json' // Assuming the request body is JSON
    });
  
    const token = sessionStorage.getItem('authToken');
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
  
    return this.http.post(url, body, { headers: headers }).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err) => {
        if (err.status === 0) {
          

          this.router.navigate(['/authentication/login']);
        

          this.snackBar.open('Your session has expired', 'Close', {
            duration: 6000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            
            panelClass: ['custom-style']
          });

          
          // this.toastr.error('Your session has expired', 'Error 401');
          this.logout();
          //this.authService.logout();
        } else {
          // this.toastr.error("Something's gone wrong", 'Error');
          this.router.navigate(['/authentication/login']);
           this.snackBar.open('Somthing is gone wrong', 'Error', {
            duration: 6000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            
            panelClass: ['custom-style']
          });
          this.logout();
        }
        const error = err.error.message || err.statusText;
        return throwError(error);
      })
    );
  }
  



 

  fnDownalodVault(url: string, body: any) : Observable<any>{
    let id =5705;
    return this.http.post<any>(url,body,
      {
        headers: new HttpHeaders({
          //responseType: 'blob'
           "Content-Type": "application/json"//,
          //"Authorization": "Bearer " + token
        })
      });
  }

  login() {
    this.authService.login().subscribe(() => {
      if (this.authService.isLoggedIn === true) {
        let redirect = this.authService.redirect ? this.authService.redirect : '/home';
        this.router.navigate([redirect]);
        return (this.authService.isLoggedIn = true);
      } else {
        return (this.authService.isLoggedIn = false);
      }
    });
  }
  logout(): void {
    this.isLoggedIn = false;
    this.toastr.success("Good Bye")
    localStorage.setItem('isLoggedIn', 'false');
    sessionStorage.removeItem('CustomerId');
    sessionStorage.removeItem("MembersData");
    // Other cleanup steps...
    this.router.navigate(['/login']);
  }
}
